import { t } from 'ttag';

const ROLE = {
  CLINIC_PHYSICIAN: 'Clinic Physician',
  CLINIC_TECHNICIAN: 'Clinic Technician',
  CALL_CENTER_QA: 'Call Center QA',
  CALL_CENTER_SUPERVISOR: 'Call Center Supervisor',
  CALL_CENTER_QA_LEADER: 'Call Center QA Leader',
  CALL_CENTER_TECHNICIAN: 'Call Center Technician',
  ADMIN: 'Admin',
  SALES_ADMIN: 'Sales Admin',
  SALES_MANAGER: 'Sales Manager',
  SALES_REP: 'Sales Representative',
  FACILITY_ADMIN: 'Facility Admin',
  BILLING_USER: 'Billing User',
};

export default ROLE;

export const LIST_ROLES_CALL_CENTER = [
  ROLE.CALL_CENTER_SUPERVISOR,
  ROLE.CALL_CENTER_QA_LEADER,
  ROLE.CALL_CENTER_TECHNICIAN,
  ROLE.CALL_CENTER_QA,
];

export const LIST_ROLES_CLINIC = [t`Clinic Physician`, t`Clinic Technician`];

export const BIOFLUX_ROLE = [t`Clinic Physician`, t`Clinic Technician`];

export const LIST_ROLES_ADMIN_OR_SALES = [
  t`Admin`,
  t`Sales Admin`,
  t`Sales Manager`,
  t`Sales Representative`,
];
